/**
 * The old Årstabell card's words while the prayer-time source is on (2026-10-03, timetable-source follow-up).
 * Norwegian only, as the rest of that card. Kept apart from the view so a test can call them (panel.test.mjs).
 */
/**
 * Where the mosque stands (the source section's status): the current table can be taken in (unadopted); versions exist
 * but none is published now (unpublished — members see the old upload); a version is published (published); or
 * neither — nothing to take in, only earlier years, or not known yet (none).
 */
export type AdoptionState = 'unadopted' | 'unpublished' | 'published' | 'none';

/**
 * What the old card says while the source is on (2026-10-03, follow-up): before adoption — and while no version is published —
 * the year listed here IS what members see, not history; once a version is published it is the record of the old uploads; and a person who cannot open the source
 * section is not sent «over» to a section they do not have.
 */
export function sourceNote(hasSource: boolean, adoption: AdoptionState | null): string {
  if (!hasSource) return 'Nye bønnetider lastes opp og godkjennes under «Bønnetidskilde», som krever egen tilgang. Årstabellen og malen vises her.';
  if (adoption === 'unadopted') return 'Dette er årstabellen appen, skjermene og nettsiden viser nå. Den er ikke tatt inn i versjonshistorikken ennå — se «Bønnetidskilde» over. Nye tider lastes opp og godkjennes der.';
  if (adoption === 'unpublished') return 'Dette er årstabellen appen, skjermene og nettsiden viser nå: ingen versjon fra «Bønnetidskilde» er publisert. Nye tider lastes opp og godkjennes der.';
  if (adoption === 'published') return 'Årstabellen og malen vises her som historikk. Nye tider lastes opp og godkjennes under «Bønnetidskilde» over.';
  return 'Nye bønnetider lastes opp og godkjennes under «Bønnetidskilde» over. Malen lastes ned her.';
}
/** Where a filled-in template goes: here while the source is off; under «Bønnetidskilde» while it is on. */
export function templateWhere(sourceOn: boolean, hasSource: boolean): string {
  if (!sourceOn) return 'last opp filen her';
  return hasSource ? 'last den opp under «Bønnetidskilde» over' : 'gi den til en som har tilgang til «Bønnetidskilde»';
}
